import React from 'react';
import {
    Alert,
    Box,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
} from '@mui/material';

export default function ImportResult({ result }) {
    if (!result) {
        return null;
    }

    const hasShippingReport = Boolean(
        result
        && (
            result.shippingCostRecords
            || result.shippingCostAssignedInvoices
            || result.shippingCostUnassignedRecords
            || result.shippingCostInvoicesWithMultipleEntries
            || (result.shippingCostUnassignedReferences && result.shippingCostUnassignedReferences.length)
        )
    );

    return (
        <Box>
            <Typography variant="subtitle1" sx={{ mb: 1 }}>
                Import-Ergebnis
            </Typography>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell>Bereich</TableCell>
                        <TableCell align="right">Importiert</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell>Profile</TableCell>
                        <TableCell align="right">{result.importedProfiles || 0}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Kunden</TableCell>
                        <TableCell align="right">{result.importedCustomers || 0}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Lieferanten</TableCell>
                        <TableCell align="right">{result.importedSuppliers || 0}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Artikel</TableCell>
                        <TableCell align="right">{result.importedArticles || 0}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Versandkosten</TableCell>
                        <TableCell align="right">{result.importedShippingCosts || 0}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Rechnungen</TableCell>
                        <TableCell align="right">{result.importedInvoices || 0}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Rechnungspositionen</TableCell>
                        <TableCell align="right">{result.importedInvoiceItems || 0}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Einnahmen</TableCell>
                        <TableCell align="right">{result.importedIncomes || 0}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Ausgaben</TableCell>
                        <TableCell align="right">{result.importedExpenses || 0}</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
            {hasShippingReport && (
                <Box sx={{ mt: 2 }}>
                    <Typography variant="subtitle2" sx={{ mb: 1 }}>
                        Versandkosten-Report
                    </Typography>
                    <Table size="small">
                        <TableBody>
                            <TableRow>
                                <TableCell>Datensaetze</TableCell>
                                <TableCell align="right">{result.shippingCostRecords || 0}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>Zugeordnete Rechnungen</TableCell>
                                <TableCell align="right">{result.shippingCostAssignedInvoices || 0}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>Nicht zuordenbar</TableCell>
                                <TableCell align="right">{result.shippingCostUnassignedRecords || 0}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>Mehrere Versandkosten</TableCell>
                                <TableCell align="right">{result.shippingCostInvoicesWithMultipleEntries || 0}</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                    {result.shippingCostUnassignedReferences?.length ? (
                        <Alert severity="warning" sx={{ mt: 1 }}>
                            Nicht zuordenbar: {result.shippingCostUnassignedReferences.join(', ')}
                        </Alert>
                    ) : null}
                </Box>
            )}
        </Box>
    );
}
